import api from './instance';

import {
  InventoryCount,
  InventoryReportTypeEnum,
  InitiateHarvestSummaryResponse,
} from 'types/inventory';
import { FetchResponse } from 'types/common';
import { toMidnightISOString } from 'utils/dateUtils';

export const createInventoryCount = async (payload: {
  site: string;
  notes?: string;
  countDate: string;
}) => {
  const { data } = await api.post('/inventory-counts/create', payload);

  return data;
};

export const fetchAllCounts = async (params: {
  page?: number;
  limit: number;
  status?: number;
  site?: Array<string>;
  washHub?: string;
  startDate?: Date;
  endDate?: Date;
  venue?: string[];
  accountManagers?: string[];
  isArchived?: boolean;
  statuses?: number[];
  sortByField?: string;
  sort?: number;
}) => {
  const endDate = toMidnightISOString(params.endDate);
  const startDate = toMidnightISOString(params.startDate);

  const { data } = await api.get<FetchResponse<InventoryCount>>(
    '/inventory-counts/list',
    {
      params: {
        ...params,
        startDate,
        endDate,
        ...(params.isArchived ? { archived: true } : null),
      },
    },
  );

  return data;
};

export const checkScheduleAvailable = async (site: string, date: string) => {
  const { data } = await api.get(
    `/inventory-counts/check-schedule?site=${site}&countDate=${date}`,
  );

  return data;
};

export const updateInventoryCount = async ({
  id,
  ...payload
}: Pick<
  InventoryCount,
  'openItems' | 'openCases' | 'sealedPackages' | 'notes' | 'countDate'
> & {
  id: string;
}) => {
  const { data } = await api.patch(`/inventory-counts/detail/${id}`, payload);

  return data;
};
export const archiveInventoryCount = async (id: string) => {
  const { data } = await api.patch(
    `report/toggle-inventory-count-archive/${id}`,
  );

  return data;
};

export const deleteInventoryCount = async (id: string) => {
  const { data } = await api.delete(`inventory-counts/delete/${id}`);

  return data;
};

export const initiateHarvestSummary = async (
  site: string,
  type: InventoryReportTypeEnum,
) => {
  const { data } = await api.get('/inventory-counts/initiate-harvest-summary', {
    params: {
      site,
      type,
    },
  });

  return data?.item as InitiateHarvestSummaryResponse;
};

export const manualRefreshTrigger = async () => {
  const { data } = await api.post(
    '/inventory-counts/manual-count-report-trigger',
  );

  return data;
};

export const manualRefreshTriggerById = async (id: string) => {
  const { data } = await api.post(
    `/inventory-counts/manual-count-report-trigger/${id}`,
  );

  return data;
};

export const exportCsvItems = async ({
  washHub,
  site,
  status,
  startDate,
  endDate,
  accountManagers,
}: {
  washHub: string;
  site?: string[];
  startDate?: Date;
  endDate?: Date;
  status?: string;
  accountManagers?: string[];
}) => {
  const { data } = await api.post(`/inventory-counts/export-counts`, {
    washHub,
    ...(site && site.length > 0 && { site }),
    ...(accountManagers && accountManagers.length > 0 && { accountManagers }),
    ...(status && status.length > 0 && { status }),
    ...(startDate && { startDate }),
    ...(endDate && { endDate }),
  });

  return data as string;
};
